export default __webpack_public_path__ + "static/media/github.756a84ae.svg";